import { Container } from "@material-ui/core"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { Desktop, Mobile } from "common/MediaQueries"
import ModelTitleAndImage from "common/ModelTitleAndImage"
import AccessoriesPage from "components/shopFeatures/accessories/AccessoriesPage"
import ColorPage from "components/shopFeatures/color/ColorPage"
import DetailingPage from "components/shopFeatures/detailing/DetailingPage"
import OrderPage from "components/shopFeatures/order/OrderPage"
import PaymentPage from "components/shopFeatures/payment/PaymentPage"
import UpholsteryPage from "components/shopFeatures/upholstery/UpholsteryPage"
import React from "react"
import { Redirect, Route, useLocation } from "react-router-dom"
import routes from "routes"
import { useTypedSelector } from "store"
import styled from "styled-components"
import SummaryPage from "../summary/SummaryPage"
import SummarySidebar from "../summary/SummarySidebar"
import { ShopFooter } from "./ShopFooter"
import { STEPS_EN } from "./constants"
import PollutionAndSafety from "./pollutionAndSafety/PollutionAndSafety"

const routesToComponents: { [path: string]: React.ComponentType } = {
  [routes.detailing.path]: DetailingPage,
  [routes.color.path]: ColorPage,
  [routes.upholstery.path]: UpholsteryPage,
  [routes.accessories.path]: AccessoriesPage,
  [routes.summary.path]: SummarySidebar,
  [routes.order.path]: function _OrderPage() {
    return (
      <>
        <Mobile>
          <OrderPage />
        </Mobile>
        <Desktop>
          <DetailingPage />
        </Desktop>
      </>
    )
  },
  [routes.payment.path]: function _PaymentPage() {
    return (
      <>
        <Mobile>
          <PaymentPage />
        </Mobile>
        <Desktop>
          <DetailingPage />
        </Desktop>
      </>
    )
  },
}

const StyledContainer = styled(Container).attrs({ maxWidth: false })<{
  $page?: string
}>`
  flex-grow: 1;
  height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${(p) =>
    p?.$page === STEPS_EN.color &&
    `padding-left: 0;
  padding-right: 0;`}

  ${(p) => p.theme.breakpoints.down("sm")} {
    background-color: ${(p) => p.theme.colors.lightGrey};
    padding-bottom: 15px;
    min-width: unset;
    height: auto;
    padding-bottom: 160px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    min-width: 450px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding-top: ${(p) => (p.$page === STEPS_EN.summary ? "47" : "60")}px;
    ${(p) => p.$page === STEPS_EN.order && "padding-top: 0;"}

    [role="tabpanel"] {
      flex-grow: 0.9;
      flex-basis: 0;
    }
  }
`
const StyledTabpanel = styled.div<{ $page: string }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-grow: 1;
    padding-top: 50px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    ${(p) => p?.$page !== STEPS_EN.summary && "align-items: center;"}
  }

  &[hidden] {
    display: none;
  }
`

const StepPage = () => {
  const { pathname } = useLocation()
  const { model } = useTypedSelector((state) => state.wizard)

  const getShopFooter = () => {
    if (pathname === STEPS_EN.summary) return <></>
    if (pathname === STEPS_EN.order || pathname === STEPS_EN.payment)
      return <ShopFooter hidePrice />
    return <ShopFooter />
  }

  return (
    <StyledContainer $page={pathname}>
      {/* There's no "root page", i.e `/`, so just redirect to the first step */}
      <Route path="/" exact>
        <Redirect to={routes.array[0].path} />
      </Route>

      {routes.array.map((route, i) => {
        const Component = routesToComponents[route.path]
        return (
          <Route path={route.path} key={route.path}>
            {({ match }) =>
              match && (
                <StyledTabpanel
                  $page={pathname}
                  role="tabpanel"
                  hidden={!match}
                  id={`steps-nav-tabpanel-${i}`}
                  aria-labelledby={`steps-nav-tab-${i}`}
                >
                  {match && route.path === "/summary" ? (
                    <SummarySidebar />
                  ) : route.path === "/order" ? (
                    <>
                      <Mobile>
                        <OrderPage />
                      </Mobile>
                      <Desktop>
                        <ModelTitleAndImage />
                      </Desktop>
                    </>
                  ) : route.path === "payment" ? (
                    <>
                      <Mobile>
                        <PaymentPage />
                      </Mobile>
                      <Desktop>
                        <SummaryPage />
                      </Desktop>
                    </>
                  ) : (
                    <Component />
                  )}
                </StyledTabpanel>
              )
            }
          </Route>
        )
      })}

      {/* In mobile, show PollutionAndSafety only in detailing, color, accessories, and summery steps */}
      <Mobile>
        {(pathname === routes.detailing.path ||
          pathname === routes.color.path ||
          pathname === routes.accessories.path) && (
          <PollutionAndSafety
            invertColor={pathname === routes.upholstery.path}
          />
        )}
        {pathname !== STEPS_EN.upholstery && (
          <BreadCrumbsWrapper
            modelName={model?.name}
            id={model?.id}
            page="configurator"
            pathname={pathname}
          />
        )}
      </Mobile>

      {getShopFooter()}
    </StyledContainer>
  )
}

export default StepPage
